( function( window, $ ) {
	'use strict';
	var document = window.document;

    var customDatalayerEvents = {

        click_publication: function() {
            $('.listing_publications-archives_btn a').click(function(){
                var roww = $(this).parent().parent().parent();
                dataLayer.push({
                   'event' : 'click_publication',
                   'pub_name' : roww.find('.listing_publications-archives_title a').text(),
                   'pub_categorie' : roww.find('.listing_publications-archives_cat').text(),
                   'pub_support' : roww.find('.listing_publications-archives_support').text()
                });
            });
        }

    };

    $(document).ready(function(){
        customDatalayerEvents.click_publication();
    });

} )(window,jQuery);
